import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Image } from '../../types'
import { CmsConverterService } from '../../../services/cms-converter/cms-converter.service'
import { ImageViewport } from '../../../enums/image-viewports'

@Injectable({ providedIn: 'root' })
export class SlimHeaderConverter extends CmsConverterService<SlimHeaderData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const xl = CmsConverterService.getImageSize(formData.st_slim_header_image_reference, ImageViewport.W10H1, 1170)
    const lg = CmsConverterService.getImageSize(formData.st_slim_header_image_reference, ImageViewport.W8H1, 970)
    const md = CmsConverterService.getImageSize(formData.st_slim_header_image_reference, ImageViewport.W6H1, 750)
    const sm = CmsConverterService.getImageSize(formData.st_slim_header_image_reference, ImageViewport.W2H1, 768)
    const xs = CmsConverterService.getImageSize(formData.st_slim_header_image_reference, ImageViewport.W2H1, 480)
    return {
      image: {
        xl,
        lg,
        md,
        sm,
        xs,
        altText: formData.st_slim_header_alternative_text?.value ||
          formData.st_slim_header_image_reference?.value?.[0]?.value?.target?.altTag || '',
        lazyLoad: formData.st_image_lazy_loading?.value ?? true,
        mime: formData.st_slim_header_image_reference?.value?.[0]?.value?.target?.mime ?? '',
      },
    }
  }
}

export const SLIM_HEADER_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, SlimHeaderData>>('SlimHeaderConverter')

export interface SlimHeaderData extends ConvertedComponentData {
  image: Image;
}
